import { render, staticRenderFns } from "./IntentExamples.vue?vue&type=template&id=4dd1bd6e&scoped=true&"
import script from "./IntentExamples.vue?vue&type=script&lang=js&"
export * from "./IntentExamples.vue?vue&type=script&lang=js&"
import style0 from "./IntentExamples.vue?vue&type=style&index=0&id=4dd1bd6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd1bd6e",
  null
  
)

export default component.exports